import { type ApolloError, gql, useQuery } from '@apollo/react-hooks';
import dayjs from 'dayjs';
import type { Merit } from './types';
import type { FileData, SelectOption } from '../../../../../../components';
import { getOptionsLabel } from '../../../../../Monitor/components';

type MeritData = {
  merit: Merit;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetMeritData = (id: string): MeritData => {
  const { data, loading, error } = useQuery(
    gql`
      query ($id: ID!) {
        programmeChoiceMetadata {
          countryList {
            value
            label
          }
        }
        merit(id: $id) {
          meritName
          awardBodyName
          supportingDocuments {
            id
            link
            name
          }
          awardDate
          country
        }
      }
    `,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: 'network-only',
    },
  );

  let merit: Merit = {
    meritName: '',
    awardBodyName: '',
    supportingDocuments: [],
    awardYear: '',
    country: '',
  };

  if (!loading) {
    const countryList =
      (data?.programmeChoiceMetadata?.countryList as SelectOption[]) ?? [];
    const countryLabel = getOptionsLabel(countryList, data?.merit?.country);

    merit = {
      meritName: data?.merit?.meritName ?? 'N/A',
      awardBodyName: data?.merit?.awardBodyName ?? 'N/A',
      supportingDocuments:
        (data?.merit?.supportingDocuments as FileData[]) ?? [],
      awardYear: (data?.merit?.awardDate as boolean)
        ? dayjs(data?.merit?.awardDate).format('YYYY')
        : 'N/A',
      country: countryLabel,
    };
  }

  return {
    merit,
    loading,
    error,
  };
};
